import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Slider from '../../Components/Slider/Slider';
import {
  fetchPopularTVShows,
  fetchTopRatedTVShows,
  fetchTVShowsByGenre,
} from '../../Api/Moviesapi';
import { ErrorState, LoadingState } from '../../Components/PageState/PageState';
// import './TvShow.css';

const TvShow = () => {
  const [popularTV, setPopularTV] = useState([]);
  const [topTV, setTopTV] = useState([]);
  const [dramaTV, setDramaTV] = useState([]);
  const [comedyTV, setComedyTV] = useState([]);
  const [status, setStatus] = useState({ loading: true, error: '' });

  useEffect(() => {
    const loadData = async () => {
      try {
        const [popular, topRated, drama, comedy] = await Promise.all([fetchPopularTVShows(), fetchTopRatedTVShows(), fetchTVShowsByGenre(18), fetchTVShowsByGenre(35)]);
        setPopularTV(popular); setTopTV(topRated); setDramaTV(drama); setComedyTV(comedy);
        setStatus({ loading: false, error: '' });
      } catch (error) { setStatus({ loading: false, error: error.message }); }
    };

    loadData();
  }, []);

  if (status.loading) return <LoadingState label="Loading TV shows…" />;
  if (status.error) return <ErrorState message={status.error} />;
  return (
    <Container fluid style={{ margin: 0, padding: 0, backgroundColor: '#111' }}>
      <Slider title="Popular TV Shows" movies={popularTV} />
      <Slider title="Top Rated TV Shows" movies={topTV} />
      <Slider title="Drama" movies={dramaTV} />
      <Slider title="Comedy" movies={comedyTV} />
    </Container>
  );
};

export default TvShow;
